import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '@shared/hooks';
import { useTickets } from '@src/library/hooks/events';
import { closePaymentModal, openDialogModal, openPaymentModal } from '@src/library/redux/modal';
import { schema, type PaymentForm } from './lib';

export const useVisitor = () => {
  /**
   * TODO: После добавления новых полей в ответ event, заменить cost и добавить wasPayed
   */
  const { visitorId, code, id } = useParams<{ visitorId: string; code: string; id: string }>();
  const { tickets } = useTickets();
  const ticket = tickets.find((ticket) => ticket.id === visitorId);

  const firstName = ticket?.first_name;
  const middleName = ticket?.middle_name;
  const lastName = ticket?.last_name;

  const navigate = useNavigate();
  const onClose = () => {
    navigate(`/events/${code}/${id}/visitors`);
  };
  //Тут сейчас как стоимость используется стоимость для клиента
  const cost = ticket?.event.cost ?? 0;
  const alreadyPayed = cost ? cost / 10 : 0; //это пока хардкод
  const isPaidFull = alreadyPayed >= cost;

  ////////////////////ExcludeVisitorModal//////////////////

  const dispatch = useAppDispatch();
  //Будет логика по исключению участника
  const exclude = (id: string | undefined) => null;

  const onExclude = (): void => {
    dispatch(
      openDialogModal({
        title: 'Исключение участника',
        text: 'Вы действительно хотите исключить участника?',
        confirmText: 'Да',
        confirm: () => exclude(id),
        declineText: 'Нет',
      })
    );
  };

  ////////////////////AcceptPaymentModal//////////////////

  const onBuy = (): void => {
    dispatch(openPaymentModal());
  };

  return {
    firstName,
    middleName,
    lastName,
    isPaidFull,
    cost,
    alreadyPayed,
    ticket,
    visitorId,
    onExclude,
    onBuy,
    onClose,
  };
};

export const usePaymentForm = () => {
  const methods = useForm<PaymentForm>({ resolver: yupResolver(schema as any) });
  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  const { ticket } = useVisitor();
  console.log(ticket);
  //const payment = ticket?.payment;
  const payment = {
    amount_paid: '2000',
    balance_due: '1400',
  };

  const dispatch = useAppDispatch();

  const submit = handleSubmit((data) => {
    console.log('Submitting payment...', data);
    dispatch(closePaymentModal());
  });

  useEffect(() => {
    /*   reset(payment as any); */
    dispatch(openPaymentModal());
  }, []);

  return {
    payment,
    methods,
    errors,
    submit,
  };
};
